import { Fragment, type ReactNode, type Ref } from 'react';
import { taglia, type Pezzo, type Rivela } from './rivela';

/** Il testo coi suoi grassetti. */
export function Pezzi({ pezzi }: { pezzi: Pezzo[] }) {
  return (
    <>
      {pezzi.map((p, i) => (p.forte ? <strong key={i}>{p.testo}</strong> : <Fragment key={i}>{p.testo}</Fragment>))}
    </>
  );
}

/**
 * La risposta mentre compare (rivela.ts). Parole, frasi o tutto: ogni unità c'è già al suo
 * posto, trasparente, e sfuma quando tocca a lei; quelle già viste al montaggio non sfumano
 * di nuovo. A scatti: il testo scritto, poi la `coda` (l'ancora con la mascotte, spinta
 * avanti), poi il resto invisibile. Negli altri modi la `coda` sta in fondo.
 */
export function TestoRivelato({ r, pezzi, coda, ultimaRef }: {
  r: Rivela;
  pezzi: Pezzo[];
  coda?: ReactNode;
  /** L'ultima unità comparsa: lo scorrimento del pannello la tiene in vista. */
  ultimaRef?: Ref<HTMLSpanElement>;
}) {
  if (r.modo === 'scatti') {
    const { scritti, resto } = taglia(pezzi, r.visibili);
    return (
      <>
        <Pezzi pezzi={scritti} />
        {coda}
        {r.scrive && <span className="ast-resto" aria-hidden="true"><Pezzi pezzi={resto} /></span>}
      </>
    );
  }
  return (
    <>
      {r.unita.map((u, i) => (
        <Fragment key={i}>
          <span
            ref={i === r.visibili - 1 ? ultimaRef : undefined}
            className="ast-u"
            data-modo={r.modo}
            data-v={i < r.visibili ? (i < r.giaAlMontaggio ? 'gia' : 'ora') : undefined}
          >
            <Pezzi pezzi={u.pezzi} />
          </span>
          {u.dopo}
        </Fragment>
      ))}
      {coda}
    </>
  );
}
